import { render, staticRenderFns } from "./jifenShop.vue?vue&type=template&id=59d93f68&scoped=true&"
import script from "./jifenShop.vue?vue&type=script&lang=ts&"
export * from "./jifenShop.vue?vue&type=script&lang=ts&"
import style0 from "./jifenShop.vue?vue&type=style&index=0&id=59d93f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d93f68",
  null
  
)

export default component.exports